var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditPictoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 3,
    height: 3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3396 5.11133H11.0001V7.41108H8.3396V5.11133Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54653 5.81983C9.74043 5.81983 9.89761 6.01758 9.89761 6.26083C9.89761 6.50483 9.74043 6.70208 9.54653 6.70208C9.35262 6.70208 9.19521 6.50483 9.19521 6.26083C9.19545 6.01758 9.35262 5.81983 9.54653 5.81983ZM8.3396 7.41108H11.0001V5.11133H8.3396V7.41108Z",
    fill: "#E9F2FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36836 2.23168L8.75779 0.435677C8.82405 0.413677 8.89078 0.423677 8.95588 0.465927C9.0626 0.535927 9.14398 0.681177 9.17281 0.855177L9.40206 2.23168H3.36836ZM11.0001 4.68619V2.98218C11.0001 2.56843 10.729 2.23168 10.3955 2.23168H9.80243L9.56086 0.780177C9.5118 0.483927 9.36556 0.237676 9.16025 0.103176C8.9996 -0.00182422 8.81475 -0.0278243 8.64061 0.0304258L2.14051 2.19643C1.97055 2.25268 1.82012 2.38743 1.71735 2.57518L1.72247 2.57868C1.66225 2.69543 1.62598 2.83343 1.62598 2.98218V6.50244C1.8894 6.42044 2.16771 6.37469 2.45601 6.37469C4.0675 6.37469 5.37835 7.74869 5.37835 9.43769C5.37835 9.7107 5.34371 9.97845 5.27652 10.2384H10.3953C10.7287 10.2384 10.9998 9.9017 10.9998 9.48794V7.83494H8.14212C8.03285 7.83494 7.94473 7.73994 7.94473 7.62269V4.89844C7.94496 4.78094 8.03331 4.68619 8.14212 4.68619H11.0001Z",
    fill: "#E9F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50988 9.68751C1.3813 9.68751 1.27714 9.57551 1.27714 9.43701C1.27714 9.29875 1.38154 9.18675 1.50988 9.18675H3.40339C3.53196 9.18675 3.63612 9.29875 3.63612 9.43701C3.63612 9.57551 3.53173 9.68751 3.40315 9.68751H1.50988ZM2.4564 6.875C1.10183 6.875 0 8.0245 0 9.43726C0 10.85 1.1016 11.9995 2.4564 11.9995C3.47337 11.9995 4.39734 11.3333 4.75586 10.3413C4.86025 10.053 4.91303 9.74876 4.91303 9.43726C4.91303 8.0245 3.81097 6.875 2.4564 6.875Z",
    fill: "#E9F2FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditPictoWhite);
export default __webpack_public_path__ + "static/media/credit-picto-white.9c5f9959.svg";
export { ForwardRef as ReactComponent };